import cx from 'classnames';

import { Icon, Text } from '../../common/components';
import { t } from '../../common/i18n';
import { CATEGORY_ICONS } from '../config/catalogConfig';
import { ServiceCategory } from '../types';

const namespace = 'OtherServices';

interface CategoryChipsProps {
  categories: ServiceCategory[];
  active: ServiceCategory | null;
  onChange: (category: ServiceCategory | null) => void;
}

/**
 * Vstup „Co řešíte?" – předseda nehledá „stavební firmu", hledá „kdo mi udělá zateplení".
 * Chipy jen filtrují karty, žádná navigace.
 */
export const CategoryChips: React.FC<CategoryChipsProps> = ({ categories, active, onChange }) => {
  if (categories.length < 2) return null;

  return (
    <div className="CategoryChips">
      <Text as="div" size="body-small" weight="600" color="Neutral700" className="CategoryChips__label">
        {t('Filter.label', namespace)}
      </Text>
      <div className="CategoryChips__list">
        <button type="button" className={cx('CategoryChips__item', active === null && 'CategoryChips__item--active')} onClick={() => onChange(null)}>
          {t('Filter.all', namespace)}
        </button>
        {categories.map((category) => (
          <button
            key={category}
            type="button"
            className={cx('CategoryChips__item', active === category && 'CategoryChips__item--active')}
            onClick={() => onChange(active === category ? null : category)}
          >
            <Icon name={CATEGORY_ICONS[category]} />
            {t(`Category.${category}`, namespace)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryChips;
